// extracted by mini-css-extract-plugin
export default {"container":"src-components-TopLabelInput-css__container--U752u","label":"src-components-TopLabelInput-css__label---dPlv"};